import { useRef } from 'react'
import { useHotkeys } from 'react-hotkeys-hook'

import { ReactComponent as IconSearchBlue } from 'assets/icons/IconSearchBlue.svg'
import { ReactComponent as IconCommandK } from 'assets/icons/IconCommandK.svg'

const SearchBox = ({ placeholder, onChange, value }) => {
  const searchInput = useRef(null)

  useHotkeys('meta+k', () => searchInput?.current?.focus())

  return (
    <div className="searchbox">
      <IconSearchBlue className="searchbox__icon-search" />
      <input
        ref={searchInput}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="searchbox__input"
        type="text"
      />
      <div className="searchbox__icon-shortcut">
        <IconCommandK />
      </div>
    </div>
  )
}

export default SearchBox
